import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BuyersGuideChecklist(props) {
    const { heading, lede, questions, pdfHref, className } = props;
    return (_jsxs("section", { className: className, "data-buyers-guide-checklist": true, "aria-labelledby": "buyers-guide-heading", style: {
            padding: 'var(--space-16) var(--space-6)',
            maxWidth: '80rem',
            margin: '0 auto',
            fontFamily: 'var(--font-ui)',
        }, children: [heading || lede ? (_jsxs("header", { style: { marginBottom: 'var(--space-8)', maxWidth: '52rem' }, children: [heading ? (_jsx("h2", { id: "buyers-guide-heading", style: {
                            margin: 0,
                            fontFamily: 'var(--font-display)',
                            fontStyle: 'italic',
                            fontSize: 'clamp(1.75rem, 5vw, var(--font-size-2xl))',
                            color: 'var(--text)',
                            overflowWrap: 'break-word',
                        }, children: heading })) : null, lede ? (_jsx("p", { style: { margin: 'var(--space-3) 0 0', color: 'var(--text-muted)', fontSize: 'var(--font-size-sm)' }, children: lede })) : null] })) : null, _jsx("ol", { style: {
                    listStyle: 'none',
                    padding: 0,
                    margin: 0,
                    display: 'grid',
                    gap: 'var(--space-4)',
                    counterReset: 'buyers-guide',
                }, children: questions.map((entry, i) => (_jsxs("li", { "data-buyers-guide-item": true, style: {
                        display: 'grid',
                        gridTemplateColumns: '3rem 1fr',
                        gap: 'var(--space-4)',
                        border: '1px solid var(--border)',
                        borderRadius: 'var(--radius-card)',
                        padding: 'var(--space-5)',
                        background: 'var(--surface)',
                        alignItems: 'start',
                    }, children: [_jsx("span", { "aria-hidden": "true", style: {
                                fontFamily: 'var(--font-mono)',
                                fontSize: 'var(--font-size-2xs)',
                                color: 'var(--text-dim)',
                                fontVariantNumeric: 'tabular-nums',
                            }, children: String(i + 1).padStart(2, '0') }), _jsxs("div", { style: { display: 'grid', gap: 'var(--space-3)', minWidth: 0 }, children: [_jsx("p", { style: {
                                        margin: 0,
                                        color: 'var(--text)',
                                        fontSize: 'var(--font-size-md)',
                                        fontFamily: 'var(--font-display)',
                                        fontStyle: 'italic',
                                        lineHeight: 'var(--line-height-display)',
                                    }, children: entry.q }), _jsx("p", { style: { margin: 0, color: 'var(--text-muted)', fontSize: 'var(--font-size-2xs)' }, children: entry.why }), _jsxs("div", { "data-buyers-guide-answer": true, style: {
                                        marginTop: 'var(--space-2)',
                                        padding: 'var(--space-3)',
                                        borderTop: '1px dashed var(--border)',
                                        display: 'grid',
                                        gap: 'var(--space-2)',
                                    }, children: [_jsxs("p", { style: { margin: 0, color: 'var(--text)', fontSize: 'var(--font-size-2xs)' }, children: [_jsx("span", { "aria-hidden": "true", style: {
                                                        display: 'inline-block',
                                                        marginRight: 'var(--space-2)',
                                                        fontFamily: 'var(--font-ui)',
                                                        fontSize: 'var(--font-size-3xs)',
                                                        color: 'var(--text-dim)',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.06em',
                                                    }, children: "gacpro" }), entry.fedsecAnswer.short] }), _jsxs("a", { href: entry.fedsecAnswer.evidenceHref, target: entry.fedsecAnswer.evidenceTarget, rel: entry.fedsecAnswer.evidenceTarget === '_blank' ? 'noopener noreferrer' : undefined, style: {
                                                color: 'var(--text)',
                                                fontSize: 'var(--font-size-2xs)',
                                                textDecoration: 'underline',
                                                textUnderlineOffset: '2px',
                                                justifySelf: 'start',
                                            }, children: [entry.fedsecAnswer.evidenceLabel, " \u2192"] })] })] })] }, i))) }), pdfHref ? (_jsxs("p", { style: {
                    marginTop: 'var(--space-6)',
                    fontSize: 'var(--font-size-2xs)',
                    color: 'var(--text-muted)',
                }, children: [_jsx("a", { href: pdfHref, style: { color: 'var(--text-muted)', textDecoration: 'underline', textUnderlineOffset: '2px' }, children: "Download the buyer's guide as a PDF \u2192" }), ' ', "\u2014 no email gate, no follow-up."] })) : null] }));
}
//# sourceMappingURL=BuyersGuideChecklist.js.map